"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import { AppDispatcher } from 'Dispatcher';
import StoreClass from '../store';
import { D5SnackbarsConstants } from 'Constants/D5SnackbarsConstants';
var _store = {
  type: '',
  open: false,
  message: ''
};
var CHANGE_EVENT = 'change';

var D5SnackbarsClass =
/*#__PURE__*/
function (_StoreClass) {
  _inherits(D5SnackbarsClass, _StoreClass);

  function D5SnackbarsClass() {
    _classCallCheck(this, D5SnackbarsClass);

    return _possibleConstructorReturn(this, _getPrototypeOf(D5SnackbarsClass).apply(this, arguments));
  }

  _createClass(D5SnackbarsClass, [{
    key: "getList",
    value: function getList() {
      return _objectSpread({}, _store);
    }
  }]);

  return D5SnackbarsClass;
}(StoreClass);

var D5SnackbarsStore = new D5SnackbarsClass();
AppDispatcher.register(function (action) {
  switch (action.actionType) {
    case D5SnackbarsConstants.SHOW_SNACKBAR:
      if (action.type) _store.type = action.type;
      if (action.message) _store.message = action.message;
      _store.open = action.open;
      D5SnackbarsStore.emit(CHANGE_EVENT);
      break;

    default:
      return true;
  }
});
export default D5SnackbarsStore;